import { Modal, message } from "antd";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { showLoding } from "../utils/tool";
import { addOrder } from "../API/card";

interface PaginationProps {
  isShow: boolean; 
  productTitle: string;
  purchaseQuantity: number;
  onConfirm?: any;
  onChange: () => void;
}
const ComponentName: React.FC<PaginationProps> = ({ isShow, onConfirm, onChange, productTitle, purchaseQuantity }) => {
  const { t } = useTranslation();

  const [password, setPassword] = React.useState('')
  useEffect(() => {
    if (isShow) {
      setPassword('')
    }
  }, []) 

  return (
    <div className=""> 
      <Modal
        title={`${'確認支付'}`}
        width={320}
        closable={{ 'aria-label': 'Custom Close Button' }}
        open={isShow}
        footer={null}
        onCancel={() => {
          onChange();
        }}
      >
        <div>
          <div className="text-[#000] text-[18px] text-center pt-[20px] font-bold line-clamp-1">{productTitle}</div>
          <div className="text-[#000] text-[18px] text-center pt-[10px] pb-[20px] font-bold">USD$ {purchaseQuantity}</div>
          <div className="flex items-center pb-[30px]">
            <div className="text-[#000] text-[16px]">支付密碼</div>
            <input type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-[206px] text-[#000] text-[16px] py-10 px-16 focus-visible:outline-none"
              placeholder="請輸入密碼支付" />
          </div>
          <div className="flex justify-center">
            <div className="bg-[#000] rounded-[4px] inline-block px-[50px] py-[10px] text-[#fff] text-[18px] cursor-pointer
                    "
              onClick={() =>
                onConfirm(password)}
            >
              確認
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default ComponentName;
